// His Profile visual scales - single source of truth
// Based on meta-analysis data: avg length 5.16", avg girth 4.59"

// Based on meta-analysis data (median 5.2")
export const HIS_SIZE_SCALE = [
  { value: 1, emoji: '🥒', label: '4-5"', percentile: 'Bottom 40%' },
  { value: 2, emoji: '🥕', label: '5-5.5"', percentile: 'Average (40-70th)' },
  { value: 3, emoji: '🍌', label: '5.5-6"', percentile: 'Top 30% (1 in 3)' },
  { value: 4, emoji: '🌽', label: '6-6.5"', percentile: 'Top 10% (1 in 10)' },
  { value: 5, emoji: '🍆', label: '6.5-7"', percentile: 'Top 2% (1 in 50)' },
  { value: 6, emoji: '🥖', label: '7-7.5"', percentile: '1 in 370' },
  { value: 7, emoji: '🏏', label: '7.5-8"', percentile: '1 in 5,800' },
  { value: 8, emoji: '🦴', label: '8-8.5"', percentile: '1 in 130,000' },
  { value: 9, emoji: '🦄', label: '8.5-9"', percentile: '1 in 3 million' },
  { value: 10, emoji: '🏆', label: '9"+', percentile: '1 in 200 million' },
] as const;

export const HIS_GIRTH_SCALE = [
  { value: 1, emoji: '○', label: 'Slim', size: '<4.2"', percentile: 'Bottom 16%' },
  { value: 2, emoji: '◯', label: 'Avg', size: '4.2-4.9"', percentile: 'Average' },
  { value: 3, emoji: '●', label: 'Thick', size: '4.9-5.3"', percentile: 'Top 16%' },
  { value: 4, emoji: '⬤', label: 'VThick', size: '5.3-5.5"', percentile: 'Top 5%' },
  { value: 5, emoji: '🔵', label: 'Wow', size: '5.5"+', percentile: 'Top 2%' },
] as const;

export const HIS_CUM_SCALE = [
  { value: 1, emoji: '💧', label: 'Drip', percentile: 'Bottom 20%' },
  { value: 2, emoji: '💦', label: 'Splash', percentile: 'Average' },
  { value: 3, emoji: '🚿', label: 'Firehose', percentile: 'Top 30%' },
  { value: 4, emoji: '🌊', label: 'Flood', percentile: 'Top 10%' },
  { value: 5, emoji: '🌊', label: 'TSUNAMI!', percentile: 'Top 1%' },
] as const;

export const HIS_CONSISTENCY_SCALE = [
  { value: 1, emoji: '💧', label: 'Watery' },
  { value: 2, emoji: '🥛', label: 'Thin' },
  { value: 3, emoji: '🍯', label: 'Normal' },
  { value: 4, emoji: '🧁', label: 'Thick' },
  { value: 5, emoji: '🍦', label: 'Creamy' },
] as const;

export const HIS_TASTE_SCALE = [
  { value: 1, emoji: '😣', label: 'Bad' },
  { value: 2, emoji: '😕', label: 'Meh' },
  { value: 3, emoji: '😐', label: 'OK' },
  { value: 4, emoji: '🙂', label: 'Good' },
  { value: 5, emoji: '😋', label: 'Yum!' },
] as const;

export const HIS_PRECUM_SCALE = [
  { value: 1, emoji: '🚫', label: 'None' },
  { value: 2, emoji: '💧', label: 'A little' },
  { value: 3, emoji: '💦', label: 'Moderate' },
  { value: 4, emoji: '🌊', label: 'A lot' },
  { value: 5, emoji: '🚿', label: 'Dripping!' },
] as const;

// =========== HER PROFILE SCALES ===========

// Wetness level (1-5)
export const HER_WETNESS_SCALE = [
  { value: 1, emoji: '💧', label: 'Light', description: 'Light moisture' },
  { value: 2, emoji: '💦', label: 'Wet', description: 'Noticeably wet' },
  { value: 3, emoji: '🌊', label: 'Very Wet', description: 'Very wet' },
  { value: 4, emoji: '🫧', label: 'Dripping', description: 'Dripping wet' },
  { value: 5, emoji: '🌧️', label: 'Soaking', description: 'Soaking wet' },
] as const;

// Squirting ability (0-5, 0 = never)
export const HER_SQUIRT_SCALE = [
  { value: 0, emoji: '🚫', label: 'Never', description: 'Has never squirted' },
  { value: 1, emoji: '💧', label: 'Rare', description: 'Rarely, under perfect conditions' },
  { value: 2, emoji: '💦', label: 'Sometimes', description: 'Sometimes, with effort' },
  { value: 3, emoji: '🚿', label: 'Often', description: 'Often, reliable' },
  { value: 4, emoji: '🌊', label: 'Easy', description: 'Easy and frequent' },
  { value: 5, emoji: '💥', label: 'Gushing', description: 'Multiple/gushing squirter' },
] as const;

// Sensitivity level (1-5)
export const HER_SENSITIVITY_SCALE = [
  { value: 1, emoji: '😌', label: 'Low', description: 'Needs a lot of stimulation' },
  { value: 2, emoji: '🙂', label: 'Moderate', description: 'Average sensitivity' },
  { value: 3, emoji: '😊', label: 'Sensitive', description: 'Quite sensitive' },
  { value: 4, emoji: '🥵', label: 'Very', description: 'Very sensitive' },
  { value: 5, emoji: '⚡', label: 'Ultra', description: 'Ultra sensitive' },
] as const;

// Orgasm ease (1-5)
export const HER_ORGASM_EASE_SCALE = [
  { value: 1, emoji: '🏔️', label: 'Difficult', description: 'Difficult to achieve' },
  { value: 2, emoji: '🧗', label: 'Takes Time', description: 'Takes time and focus' },
  { value: 3, emoji: '🎯', label: 'Average', description: 'Average ease' },
  { value: 4, emoji: '🎆', label: 'Easy', description: 'Comes easily' },
  { value: 5, emoji: '🎇', label: 'Multiple', description: 'Multiple orgasms easily' },
] as const;

// Type helpers
export type HisSizeValue = typeof HIS_SIZE_SCALE[number]['value'];
export type HisGirthValue = typeof HIS_GIRTH_SCALE[number]['value'];
export type HisCumValue = typeof HIS_CUM_SCALE[number]['value'];
export type HisConsistencyValue = typeof HIS_CONSISTENCY_SCALE[number]['value'];
export type HisTasteValue = typeof HIS_TASTE_SCALE[number]['value'];
export type HisPrecumValue = typeof HIS_PRECUM_SCALE[number]['value'];

// Her profile type helpers
export type HerWetnessValue = typeof HER_WETNESS_SCALE[number]['value'];
export type HerSquirtValue = typeof HER_SQUIRT_SCALE[number]['value'];
export type HerSensitivityValue = typeof HER_SENSITIVITY_SCALE[number]['value'];
export type HerOrgasmEaseValue = typeof HER_ORGASM_EASE_SCALE[number]['value'];
